<form [formGroup]="form" class="form-container ng" novalidate
    (ngSubmit)="save(form.value)">
  <h1>{{'Forgot password' | translate}}</h1>

  <div class="form-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-between center">
    <label class="control-label" fxFlex="40">
      {{'Email address' | translate}} *
    </label>
    <div class="input-container" fxFlex="60" fxLayout="column">
      <input
        formControlName="userEmail"
        class="form-control"
        maxlength="50"
        id="exampleInputEmail1" name="exampleInputEmail1"
        aria-describedby="emailHelp">
      <div fxLayout="column" class="feedback-wrapper"
          *ngIf="form.controls['userEmail'].errors && (form.controls['userEmail'].dirty || form.controls['userEmail'].touched)">
        <small [hidden]="!form.controls['userEmail'].errors.required" class="feedback">
          {{'Required' | translate}}.
        </small>
        <small [hidden]="!form.controls['userEmail'].errors.pattern" class="feedback">
          {{'Email must have the format john.doe@example.com' | translate}}.
        </small>
      </div>
    </div>
  </div>

  <div class="form-group" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center">
    <button id="resetPassword" type="submit" class="btn btn-primary" [disabled]="form.invalid">
      {{'reset password' | translate}}
    </button>
  </div>

</form>

<hr>
